import React, {createRef} from "react"
import {findDOMNode} from "react-dom"

import Breadcrumbs from '../../../../core/gd-components/breadcrumbs/breadcrumbs'
import FinderEvent from "../items/event/finder-event"
import FinderProject from '../items/project/finder-project'
import VScroll from "../../scrolling/custom-v-scroll/v-scroll"
import EventsCollection from "../../../model2/event/collection"
import Event from "../../../model2/event/event"

type Props = {
    selectedEventId?: ID
    parentProjectId?: ID | null

    search?         : string
    data            : EventsCollection | null

    isSearching?    : boolean

    onClickCompany? : func
    onClickProject? : func
    onClickEvent?   : func
}

type State = {
    currentCursorKey: any
}

const debug = false
// const debug = "EventFinderMain"

export default class EventFinderMain extends React.Component<Props, State> {

    private scrollRef: any          = createRef()
    private selectedItemRef: any    = createRef()

    private optionsLength: number   = 0

    constructor(props: Props) {
        super(props)

        debug && console.log(debug, 'constructor', this.props.data)

        this.state = {
            currentCursorKey: null
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        debug && console.log(debug, 'componentDidUpdate', this.state.currentCursorKey)

        if (this.scrollRef.current) {
            const node: any = findDOMNode(this.selectedItemRef.current)
            if (node) {
                this.scrollRef.current?.setScrollTop(node.offsetTop + node.clientHeight/2,true,250)
            }
        }
    }

    onKeyDown = (event: any) => {
        debug && console.log(debug, 'onKeyDown', this.state.currentCursorKey, event)

        let newValue
        switch(event.code){
            case 'ArrowUp':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'ArrowDown':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > this.optionsLength - 1) newValue = this.optionsLength - 1;
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'Enter':
                event.preventDefault()
                event.stopPropagation()

                if (this.selectedItemRef.current) this.selectedItemRef.current.click()
                break
        }
    }

    renderItems() {
        if (this.props.isSearching) {
            return <div className="searching-label">Searching events...</div>
        } else {
            let res: any[] = [], filteredProjects = [], baseKey = 0

            // do not show projects if search is active or recent tasks are shown
            if (!this.props.search) {
                const projects      = gd.tree.findCompanyChildren(gd.companyId)
                filteredProjects    = _.orderBy(_.filter(projects, p=>p.systemType !== gd.const.project.type.TAG && p.parentId === this.props.parentProjectId), p=>p.name.toLowerCase())
                _.map(filteredProjects, (p,key)=>{
                    const isSelected = key === this.state.currentCursorKey
                    res.push(<FinderProject ref             = {isSelected ? this.selectedItemRef : null}
                                            key             = {p.id}
                                            isHighlighted   = {isSelected}
                                            project         = {p}
                                            onClickProject  = {this.props.onClickProject}/>)
                })
                baseKey = filteredProjects.length
            }

            if (this.props.data) {
                const filteredTasks = _.orderBy(this.props.data.models, (event: Event)=>event.sortPosition)
                _.map(filteredTasks, (event: Event,key)=>{
                    const itemKey = baseKey + key
                    const isSelected = itemKey === this.state.currentCursorKey
                    res.push(<FinderEvent ref                = {isSelected ? this.selectedItemRef : null}
                                          key                = {event.id}
                                          isHighlighted      = {isSelected}
                                          event              = {event}
                                          onClickEvent       = {this.props.onClickEvent}
                                          showParentProject  = {!!this.props.search}
                                          selected           = {this.props.selectedEventId === event.id}/>)
                })
            }

            const tasksLength = this.props.data ? this.props.data.length : 0
            if (!this.props.search) {
                this.optionsLength = filteredProjects.length + tasksLength
            } else {
                this.optionsLength = tasksLength
            }

            return <div className="search-items">{res}</div>
        }
    }

    renderNotification() {
        const projects      = _.filter(gd.tree.findCompanyChildren(gd.companyId), p=>p.parentId === this.props.parentProjectId)
        const showNoTasks   = projects.length <= 0 && !!this.props.parentProjectId && !!this.props.data && this.props.data.length === 0 && !this.props.search
        const noMatches     = !!this.props.data && this.props.data.length === 0 && !!this.props.search && !this.props.isSearching
        const showLoading   = !this.props.data && !this.props.search && !this.props.isSearching

        let label = null
        if (showNoTasks) label = <div className="not-found">No events found</div>
        else if (noMatches) label = <div className="not-found">No events found</div>
        else if (showLoading) label = <div className="not-found">Loading...</div>

        return label
    }

    render() {
        return (
            <div ref="main" className="finder-main">
                <VScroll ref            = {this.scrollRef}
                         containerClass = "finder-main-container"
                         minDragHeight  = {20}>
                    {!this.props.search && this.props.parentProjectId &&
                        <Breadcrumbs className                      = "finder-breadcrumbs"
                                     companyId                      = {gd.companyId}
                                     projectId                      = {null}
                                     currentProject                 = {this.props.parentProjectId}
                                     currentProjectAsLastBreadcrumb = {true}
                                     onNavigateCompany              = {this.props.onClickCompany}
                                     onNavigateProject              = {this.props.onClickProject}/>}

                    {!this.props.search && this.props.parentProjectId &&
                        <div className="horizontal-separator"/>}

                    {this.renderItems()}
                    {this.renderNotification()}
                </VScroll>
            </div>
        );
    }
}